class InstagramCarousel extends HTMLElement {
  constructor() {
    super();

    this.instagramItemEls = this.querySelectorAll('.instagram-carousel__item')
    this.instagramModalEl = this.querySelector('.js-instagram-modal')
    this.closeModal = this.instagramModalEl.querySelector('.js-close-modal')
    this.contentModalEls = this.querySelectorAll('.js-modal-content')
  }

  connectedCallback() {
    this.initCarouselInstagram();
    this.openInstagramModal();
    this.closeInstagramModal();
  }

  initCarouselInstagram() {
    const sectionId = this.dataset.sectionId;
    this.swiperInsta = new Swiper(`.js-instagram-carousel-${sectionId} .swiper`, {
      slidesPerView: 1.7,
      centeredSlides: true,
      spaceBetween: 10,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 3.5,
          spaceBetween: 18,
          centeredSlides: false
        },
        1440: {
          slidesPerView: 4.7,
          spaceBetween: 20,
          centeredSlides: false
        },
      },
    });
  }

  openInstagramModal() {
    console.log('this.swiperInsta', this.swiperInsta)

    if (this.swiperInsta) {
      this.swiperInsta.on('click', (swiper) => {
        const slides = swiper.slides
        const currentIndex = swiper.clickedIndex
        const blockId = slides[currentIndex].dataset.blockId
        const contentModal = this.querySelector(`.js-modal-content[data-block-id="${blockId}"]`)

        this.removeAllClassActive(this.contentModalEls, 'is-content-active')
        this.instagramModalEl && this.instagramModalEl.classList.add('is-active')
        contentModal && contentModal.classList.add('is-content-active')
      })
    }
  }

  closeInstagramModal() {
    if (this.closeModal) {
      this.closeModal.addEventListener('click', () => {
        this.instagramModalEl && this.instagramModalEl.classList.remove('is-active')
      })
    }
  }

  removeAllClassActive(items, classActive) {
    if (!items.length) return

    items.forEach(item => {
      item.classList.remove(classActive)
    });
  }
}

if (!customElements.get("instagram-carousel")) {
  customElements.define("instagram-carousel", InstagramCarousel);
}
